import { createContext } from 'react'

import { EntitySortOrder, EntityType, XyoWorldEntity } from '../../Hooks'
import { SortableEntity } from './EntitySorting'

export interface EntityList {
  entityList?: XyoWorldEntity[]
  filter?: EntityType
  sortOrder?: EntitySortOrder
  sortedEntityList?: SortableEntity[]
  update?: (clear?: boolean) => void
  updateFilter?: (filter: EntityType) => void
  updateSortOrder?: (order: EntitySortOrder) => void
}

export const EntityListContext = createContext<EntityList>({})
